<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates21">
<p class="centerImage"><img alt="images" id="plate21" src="images/plate21.jpg"/></p>
<p class="caption">Pilots of 54 Squadron at Richmond, November 1942. Front (left to right): PO G Wall, PO A McIntyre, FO R Beaton (EO), FL E Weatherhead (Adj), RFW, SL E M Gibbs, FL R Norwood, FL D G Jarman (MO), PO J Councer (IO), PO A K Brook, PO G C F Farries. Rear: Sgt Studley, Sgt W Eldred, FS B Mahoney, FS Miller, FS F L Varney(†), FS J C Wellsman(†), Sgt D Monger, Sgt G Horkin, Sgt P F McCarthy (†). († - killed with the Wing)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates21.vue?0fca5e61